import { FE_ENABLE_FETCH_PRODUCT_REVIEW_COUNT_250630 } from "@faire/retailer-settings/FE_ENABLE_FETCH_PRODUCT_REVIEW_COUNT_250630";

import { useReviewsHoldoutGatedFESetting } from "./useReviewsHoldoutGatedSetting";

export const useSettingEnableFetchProductReviewCount = (): boolean =>
  useReviewsHoldoutGatedFESetting(
    FE_ENABLE_FETCH_PRODUCT_REVIEW_COUNT_250630,
    false
  );
